import { UserBooking, PostInstallationDocuments } from "../../types/responseTypes";

async function getInstallationDocuments(booking: UserBooking): Promise<PostInstallationDocuments | null> {
  try {
      const url = `https://ruuf-backend.online/installation/${booking.installationId}/post-installation-documents`;
      const timeout = new Promise<Response>((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000),
      );
      const response = await Promise.race([
        fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }),
        timeout,
      ]);

      if (!(response instanceof Response)) {
        throw response;
      }
      if (response.status === 200) {
        const documents = await response.json();
        console.log("Post installation docs fetch succesfully: ", documents);
        return documents;
      } else {
        throw new Error("Could not fetch installation docs");
      }
    } catch (error) {
      console.error("Error fetching installation docs:", error);
      return null;
    }
}

export default getInstallationDocuments;
